export const actionTypes = {
  REQUEST_START: 'TAPS.REGIONS.TAX_AUTHORITY.LIST.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.REGIONS.TAX_AUTHORITY.LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.REGIONS.TAX_AUTHORITY.LIST.REQUEST_FAILURE',
};

export function startRequest(regionId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: regionId,
  };
}

export function requestSuccess(data, regionId) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { data, regionId },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
